/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportTreatmentBookingVolumeItemDTO { 
    treatmentType: ReportTreatmentBookingVolumeItemDTO.TreatmentTypeEnum;
    /**
     * The number of the bookings
     */
    count: number;
    /**
     * the volume of the bookings
     */
    volume: number;
    /**
     * the volume of the prepaid bookings
     */
    volumePrepaid: number;
}
export namespace ReportTreatmentBookingVolumeItemDTO {
    export const TreatmentTypeEnum = {
        hair: 'hair',
        beauty: 'beauty',
        body: 'body',
        health: 'health',
        combo: 'combo'
    } as const;
    export type TreatmentTypeEnum = typeof TreatmentTypeEnum[keyof typeof TreatmentTypeEnum];
}


